"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = unselectable;
function unselectable() {
  return "\n    -moz-user-select: none;\n    -khtml-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  ";
}